export const redirectMap: Record<string, string> = {
    'fast-signup': '/user/quick-signup',
    'quick-signup': '/user/quick-signup',
    'registration': '/user/signup',
  };
